import { Injectable } from "@angular/core";
import { AuthService } from "src/services/auth/auth.service";
import { MessageService } from "src/services/message/message.service";
import { Maybe } from "../utils/type.utils";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  constructor(
    private readonly authService: AuthService,
    private readonly messageService: MessageService,
  ) {}

  public async loginWithEmail(email: string, password: string, onSuccess?: () => void | Promise<void>): Promise<void> {
    try {
      const result = await this.authService.loginWithEmailUser(email, password);

      if (!result.user) {
        throw new Error("Authentication succeeded but no user was returned.");
      }

      await this.authService.loginComplete(result.user.uid, onSuccess);
    } catch (error) {
      await this.handleLoginErrors(error);
    }
  }

  public async registerWithEmail(
    email: string,
    password: string,
    firstName: Maybe<string>,
    lastName: Maybe<string>,
    phone?: Maybe<string>,
    onSuccess?: () => void | Promise<void>,
  ): Promise<void> {
    try {
      const result = await this.authService.registerByEmail(email, password);
      await this.authService.createUserIfNotExist(result, { firstName, lastName, phoneNumber: phone }, true, onSuccess);
    } catch (error) {
      await this.handleLoginErrors(error);
    }
  }

  private async handleLoginErrors(error: any): Promise<void> {
    await this.messageService.presentErrorToast(await AuthService.getErrorMessageToDisplay(error));
  }
}
